/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Visit } from '../housien-models/Visit';
import type { VisitInput } from '../housien-models/VisitInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPIHousien } from '../core/OpenAPI';
import { request as __request } from '../core/request';

/**
 * VisitsService class.
 */
export class VisitsService {

    /**
     * Retrieve all visits for a property
     * Get a list of all visits scheduled for a specific property under an agency.
     * @param agencyId The ID of the agency managing the property.
     * @param agencyId The ID of the agency.
     * @param page Number of page
     * @param limit Number of properties per page
     * @returns any List of visits retrieved successfully.
     * @throws ApiError
     */
    public static getPropertyVisits(
agencyId: string,
page: number = 1,
limit: number = 10,
startDate?: string,
endDate?: string,
clientId?: string,
propertyId?: string,
brokerEmail?: string,
): CancelablePromise<{
/**
 * A list of visits.
 */
data?: Array<Visit>;
/**
 * The first page number.
 */
first?: number;
/**
 * The number of items per page.
 */
items?: number;
/**
 * The last page number.
 */
last?: number;
/**
 * The total number of pages.
 */
pages?: number;
/**
 * URL for the next page of results, if applicable.
 */
next?: string | null;
/**
 * URL for the previous page of results, if applicable.
 */
prev?: string | null;
}> {
        return __request(OpenAPIHousien, {
            method: 'GET',
            url: '/agency/{agencyId}/visits',
            path: {
                'agencyId': agencyId,
            },
            query: {
                'page': page,
                'page_size': limit,
                'start_date': startDate,
                'end_date': endDate,
                'client_id': clientId,
                'property_id': propertyId,
                'broker_email': brokerEmail,
            },
        });
    }

    /**
     * Schedule a visit under an existing attendance.
     *
     * The attendance travels in the path, never in the body — the server
     * refuses to read it from a payload. Use this when the broker picked
     * an attendance; `scheduleVisit` opens a new one instead.
     *
     * @param agencyId The ID of the agency managing the property.
     * @param dealId The attendance the visit belongs to.
     * @param requestBody
     * @returns Visit Visit scheduled successfully.
     * @throws ApiError
     */
    public static scheduleVisitUnderDeal(
        agencyId: string,
        dealId: string,
        requestBody: VisitInput,
    ): CancelablePromise<Visit> {
        return __request(OpenAPIHousien, {
            method: 'POST',
            url: '/agency/{agencyId}/deals/{dealId}/visits',
            path: {
                'agencyId': agencyId,
                'dealId': dealId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Schedule a new visit
     * Create a new visit for a property under an agency.
     * @param agencyId The ID of the agency managing the property.
     * @param requestBody
     * @returns Visit Visit scheduled successfully.
     * @throws ApiError
     */
    public static scheduleVisit(
agencyId: string,
requestBody: VisitInput,
): CancelablePromise<Visit> {
        return __request(OpenAPIHousien, {
            method: 'POST',
            url: '/agency/{agencyId}/visits',
            path: {
                'agencyId': agencyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Retrieve visit details
     * Get details of a specific visit.
     * @param agencyId The ID of the agency managing the property.
     * @param visitId The ID of the visit.
     * @returns Visit Visit details retrieved successfully.
     * @throws ApiError
     */
    public static getVisitDetails(
agencyId: string,
visitId: string,
): CancelablePromise<Visit> {
        return __request(OpenAPIHousien, {
            method: 'GET',
            url: '/agency/{agencyId}/visits/{visitId}',
            path: {
                'agencyId': agencyId,
                'visitId': visitId,
            },
        });
    }

    /**
     * Update visit details
     * Modify an existing visit's details.
     * @param agencyId The ID of the agency managing the property.
     * @param visitId The ID of the visit.
     * @param requestBody 
     * @returns Visit Visit updated successfully.
     * @throws ApiError
     */
    public static updateVisit(
agencyId: string,
visitId: string,
requestBody: VisitInput,
): CancelablePromise<Visit> {
        return __request(OpenAPIHousien, {
            method: 'PUT',
            url: '/agency/{agencyId}/visits/{visitId}',
            path: {
                'agencyId': agencyId,
                'visitId': visitId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Cancel a visit
     * Remove an existing visit.
     * @param agencyId The ID of the agency managing the property.
     * @param visitId The ID of the visit.
     * @returns void 
     * @throws ApiError
     */
    public static deleteVisit(
agencyId: string,
visitId: string,
): CancelablePromise<void> {
        return __request(OpenAPIHousien, {
            method: 'DELETE',
            url: '/agency/{agencyId}/visits/{visitId}',
            path: {
                'agencyId': agencyId,
                'visitId': visitId,
            },
        });
    }

}
